// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════
   AttendanceCapturePage
   ══════════════════════════════════════════════════════════ */

.acp-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f5f7fa;
}

/* ── Header ──────────────────────────────────────────── */
.acp-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  background: #fff;
  border-bottom: 1px solid #eaecf0;
}

.acp-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: #f0f2f5;
  color: #374151;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.acp-back-btn:hover { background: #e5e7eb; }

.acp-header-text h1 {
  font-size: 17px;
  font-weight: 700;
  color: #1a2236;
  margin: 0;
}
.acp-header-text p {
  font-size: 12px;
  color: #6b7280;
  margin: 2px 0 0;
}

/* ── Employee not found ──────────────────────────────── */
.acp-emp-not-found {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin: 24px;
  padding: 20px 24px;
  border-radius: 12px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #78350f;
}
.acp-emp-not-found-icon {
  flex-shrink: 0;
  color: #d97706;
  margin-top: 2px;
}
.acp-emp-not-found-body {
  flex: 1;
}
.acp-emp-not-found-body strong {
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 6px;
}
.acp-emp-not-found-body p {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #92400e;
}
.acp-emp-not-found-retry {
  margin-top: 12px;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #d97706;
  background: #fff;
  color: #92400e;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  align-self: center;
  flex-shrink: 0;
}
.acp-emp-not-found-retry:hover { background: #fffbeb; }
.dark .acp-emp-not-found {
  background: #2d1a00;
  border-color: #78350f;
  color: #fbbf24;
}
.dark .acp-emp-not-found-icon { color: #fbbf24; }
.dark .acp-emp-not-found-body p { color: #fcd34d; }
.dark .acp-emp-not-found-retry {
  background: #2d1a00;
  border-color: #78350f;
  color: #fcd34d;
}

/* ── Preflight loading ───────────────────────────────── */
.acp-preflight-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 60px 24px;
  color: #6b7280;
  font-size: 14px;
}

/* ── Body ────────────────────────────────────────────── */
.acp-body {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 32px 24px;
}

.acp-camera-card {
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

/* ── Video area ──────────────────────────────────────── */
.acp-video-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 12px;
  overflow: hidden;
  background: #111827;
}

.acp-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.3s;
}
.acp-video.ready { opacity: 1; }

.acp-video-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #94a3b8;
  font-size: 14px;
}

.acp-camera-error {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #94a3b8;
  padding: 20px;
  text-align: center;
  font-size: 14px;
}

/* Face guide oval */
.acp-face-guide {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.acp-face-guide::after {
  content: "";
  width: 52%;
  aspect-ratio: 3 / 4;
  border: 2.5px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.35);
}

/* ── Spinner ─────────────────────────────────────────── */
.acp-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #e2e8f0;
  border-top-color: #1e5fbc;
  border-radius: 50%;
  animation: acp-spin 0.7s linear infinite;
}
@keyframes acp-spin { to { transform: rotate(360deg); } }

/* ── Status row ──────────────────────────────────────── */
.acp-status {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #6b7280;
}

/* ── Result card ─────────────────────────────────────── */
.acp-result {
  width: 100%;
  border-radius: 12px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
}
.acp-result.success {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}
.acp-result.error {
  background: #fff1f2;
  border: 1px solid #fecdd3;
  color: #be123c;
  font-size: 14px;
}

.acp-result-name {
  font-size: 18px;
  font-weight: 700;
  color: #1a2236;
}

.acp-badge {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.acp-badge.in  { background: #dcfce7; color: #15803d; }
.acp-badge.out { background: #fef3c7; color: #92400e; }

.acp-result-time {
  font-size: 13px;
  color: #6b7280;
}

/* ── Rich result popup ───────────────────────────────── */
.acp-result-popup {
  width: 100%;
  border-radius: 14px;
  padding: 20px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  background: linear-gradient(135deg, #f0fdf4, #dcfce7);
  border: 1px solid #86efac;
  animation: acp-pop-in 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes acp-pop-in {
  from { transform: scale(0.93); opacity: 0; }
  to   { transform: scale(1);    opacity: 1; }
}

.acp-action-badge {
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}
.acp-action-badge.in  { background: #dcfce7; color: #15803d; }
.acp-action-badge.out { background: #dbeafe; color: #1e40af; }

.acp-result-name {
  font-size: 20px;
  font-weight: 800;
  color: #1a2236;
  line-height: 1.2;
}
.acp-result-empid {
  font-size: 12px;
  color: #9ca3af;
  font-weight: 500;
  margin-top: -4px;
}
.acp-result-confidence {
  font-size: 12px;
  color: #6b7280;
}
.acp-result-confidence strong { color: #16a34a; }

.acp-result-times {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}
.acp-time-pill {
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}
.acp-time-pill.in  { background: #dcfce7; color: #15803d; }
.acp-time-pill.out { background: #dbeafe; color: #1e40af; }

.acp-result-late {
  font-size: 12px;
  font-weight: 600;
  color: #c2410c;
  background: #ffedd5;
  padding: 4px 12px;
  border-radius: 8px;
}
.acp-result-location {
  font-size: 12px;
  color: #6b7280;
}

/* ── Capture button ──────────────────────────────────── */
.acp-capture-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #0d1b3e, #1e5fbc);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
}
.acp-capture-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
.acp-capture-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ══════════════════════════════════════════════════════════
   Dark mode
   ══════════════════════════════════════════════════════════ */
.dark .acp-root { background: #121827; }
.dark .acp-header { background: #1a2236; border-color: #2e3d52; }
.dark .acp-header-text h1 { color: #e2e8f0; }
.dark .acp-header-text p { color: #94a3b8; }
.dark .acp-back-btn { background: #263348; color: #cbd5e1; }
.dark .acp-back-btn:hover { background: #2e3d52; }
.dark .acp-camera-card { background: #1a2236; box-shadow: 0 4px 24px rgba(0,0,0,0.3); }
.dark .acp-result.success { background: #052e16; border-color: #166534; }
.dark .acp-result-name { color: #e2e8f0; }
.dark .acp-result.error { background: #1f0a10; border-color: #9f1239; color: #fb7185; }
.dark .acp-status { color: #94a3b8; }
.dark .acp-spinner { border-color: #2e3d52; border-top-color: #7eb3ff; }

/* Dark: rich result popup */
.dark .acp-result-popup { background: linear-gradient(135deg, #052e16, #064e3b); border-color: #065f46; }
.dark .acp-action-badge.in  { background: #052e16; color: #4ade80; }
.dark .acp-action-badge.out { background: #1e3a5f; color: #93c5fd; }
.dark .acp-result-name { color: #e2e8f0; }
.dark .acp-result-empid { color: #4b5e76; }
.dark .acp-result-confidence { color: #94a3b8; }
.dark .acp-result-confidence strong { color: #4ade80; }
.dark .acp-time-pill.in  { background: #052e16; color: #4ade80; }
.dark .acp-time-pill.out { background: #1e3a5f; color: #93c5fd; }
.dark .acp-result-late { background: #3b1505; color: #fb923c; }
.dark .acp-result-location { color: #64748b; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/AttendanceCapturePage.css"],"names":[],"mappings":"AAAA;;+DAE+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,OAAO;AACT;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA,iCAAiC,mBAAmB,EAAE;AACtD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,gCAAgC,cAAc,EAAE;AAChD,kCAAkC,cAAc,EAAE;AAClD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,wBAAwB;AAC1B;AACA,mBAAmB,UAAU,EAAE;;AAE/B;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;;AAExD,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;;AAEtD;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,yBAAyB;EACzB,yDAAyD;AAC3D;AACA;EACE,OAAO,sBAAsB,EAAE,UAAU,EAAE;EAC3C,OAAO,mBAAmB,KAAK,UAAU,EAAE;AAC7C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA,gCAAgC,cAAc,EAAE;;AAEhD;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;AACA,wCAAwC,YAAY,EAAE,2BAA2B,EAAE;AACnF,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;;AAE/D;;+DAE+D;AAC/D,kBAAkB,mBAAmB,EAAE;AACvC,oBAAoB,mBAAmB,EAAE,qBAAqB,EAAE;AAChE,4BAA4B,cAAc,EAAE;AAC5C,2BAA2B,cAAc,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,4BAA4B,mBAAmB,EAAE;AACjD,yBAAyB,mBAAmB,EAAE,sCAAsC,EAAE;AACtF,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE;AACxE,yBAAyB,cAAc,EAAE;AACzC,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACtF,oBAAoB,cAAc,EAAE;AACpC,qBAAqB,qBAAqB,EAAE,yBAAyB,EAAE;;AAEvE,4BAA4B;AAC5B,0BAA0B,qDAAqD,EAAE,qBAAqB,EAAE;AACxG,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,yBAAyB,cAAc,EAAE;AACzC,0BAA0B,cAAc,EAAE;AAC1C,+BAA+B,cAAc,EAAE;AAC/C,sCAAsC,cAAc,EAAE;AACtD,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,6BAA6B,cAAc,EAAE","sourcesContent":["/* ══════════════════════════════════════════════════════════\n   AttendanceCapturePage\n   ══════════════════════════════════════════════════════════ */\n\n.acp-root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: #f5f7fa;\n}\n\n/* ── Header ──────────────────────────────────────────── */\n.acp-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 20px;\n  background: #fff;\n  border-bottom: 1px solid #eaecf0;\n}\n\n.acp-back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: none;\n  background: #f0f2f5;\n  color: #374151;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n.acp-back-btn:hover { background: #e5e7eb; }\n\n.acp-header-text h1 {\n  font-size: 17px;\n  font-weight: 700;\n  color: #1a2236;\n  margin: 0;\n}\n.acp-header-text p {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 2px 0 0;\n}\n\n/* ── Employee not found ──────────────────────────────── */\n.acp-emp-not-found {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  margin: 24px;\n  padding: 20px 24px;\n  border-radius: 12px;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  color: #78350f;\n}\n.acp-emp-not-found-icon {\n  flex-shrink: 0;\n  color: #d97706;\n  margin-top: 2px;\n}\n.acp-emp-not-found-body {\n  flex: 1;\n}\n.acp-emp-not-found-body strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n.acp-emp-not-found-body p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #92400e;\n}\n.acp-emp-not-found-retry {\n  margin-top: 12px;\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: 1px solid #d97706;\n  background: #fff;\n  color: #92400e;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  align-self: center;\n  flex-shrink: 0;\n}\n.acp-emp-not-found-retry:hover { background: #fffbeb; }\n.dark .acp-emp-not-found {\n  background: #2d1a00;\n  border-color: #78350f;\n  color: #fbbf24;\n}\n.dark .acp-emp-not-found-icon { color: #fbbf24; }\n.dark .acp-emp-not-found-body p { color: #fcd34d; }\n.dark .acp-emp-not-found-retry {\n  background: #2d1a00;\n  border-color: #78350f;\n  color: #fcd34d;\n}\n\n/* ── Preflight loading ───────────────────────────────── */\n.acp-preflight-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 60px 24px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* ── Body ────────────────────────────────────────────── */\n.acp-body {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 32px 24px;\n}\n\n.acp-camera-card {\n  width: 100%;\n  max-width: 520px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n/* ── Video area ──────────────────────────────────────── */\n.acp-video-wrap {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #111827;\n}\n\n.acp-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n.acp-video.ready { opacity: 1; }\n\n.acp-video-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.acp-camera-error {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: #94a3b8;\n  padding: 20px;\n  text-align: center;\n  font-size: 14px;\n}\n\n/* Face guide oval */\n.acp-face-guide {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n.acp-face-guide::after {\n  content: \"\";\n  width: 52%;\n  aspect-ratio: 3 / 4;\n  border: 2.5px solid rgba(255, 255, 255, 0.6);\n  border-radius: 50%;\n  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.35);\n}\n\n/* ── Spinner ─────────────────────────────────────────── */\n.acp-spinner {\n  width: 28px;\n  height: 28px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #1e5fbc;\n  border-radius: 50%;\n  animation: acp-spin 0.7s linear infinite;\n}\n@keyframes acp-spin { to { transform: rotate(360deg); } }\n\n/* ── Status row ──────────────────────────────────────── */\n.acp-status {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n/* ── Result card ─────────────────────────────────────── */\n.acp-result {\n  width: 100%;\n  border-radius: 12px;\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  text-align: center;\n}\n.acp-result.success {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n}\n.acp-result.error {\n  background: #fff1f2;\n  border: 1px solid #fecdd3;\n  color: #be123c;\n  font-size: 14px;\n}\n\n.acp-result-name {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a2236;\n}\n\n.acp-badge {\n  display: inline-block;\n  padding: 4px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n.acp-badge.in  { background: #dcfce7; color: #15803d; }\n.acp-badge.out { background: #fef3c7; color: #92400e; }\n\n.acp-result-time {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* ── Rich result popup ───────────────────────────────── */\n.acp-result-popup {\n  width: 100%;\n  border-radius: 14px;\n  padding: 20px 18px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  text-align: center;\n  background: linear-gradient(135deg, #f0fdf4, #dcfce7);\n  border: 1px solid #86efac;\n  animation: acp-pop-in 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n@keyframes acp-pop-in {\n  from { transform: scale(0.93); opacity: 0; }\n  to   { transform: scale(1);    opacity: 1; }\n}\n\n.acp-action-badge {\n  display: inline-block;\n  padding: 5px 16px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n.acp-action-badge.in  { background: #dcfce7; color: #15803d; }\n.acp-action-badge.out { background: #dbeafe; color: #1e40af; }\n\n.acp-result-name {\n  font-size: 20px;\n  font-weight: 800;\n  color: #1a2236;\n  line-height: 1.2;\n}\n.acp-result-empid {\n  font-size: 12px;\n  color: #9ca3af;\n  font-weight: 500;\n  margin-top: -4px;\n}\n.acp-result-confidence {\n  font-size: 12px;\n  color: #6b7280;\n}\n.acp-result-confidence strong { color: #16a34a; }\n\n.acp-result-times {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.acp-time-pill {\n  padding: 4px 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.acp-time-pill.in  { background: #dcfce7; color: #15803d; }\n.acp-time-pill.out { background: #dbeafe; color: #1e40af; }\n\n.acp-result-late {\n  font-size: 12px;\n  font-weight: 600;\n  color: #c2410c;\n  background: #ffedd5;\n  padding: 4px 12px;\n  border-radius: 8px;\n}\n.acp-result-location {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* ── Capture button ──────────────────────────────────── */\n.acp-capture-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 32px;\n  border-radius: 10px;\n  border: none;\n  background: linear-gradient(135deg, #0d1b3e, #1e5fbc);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.15s, transform 0.1s;\n}\n.acp-capture-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }\n.acp-capture-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ══════════════════════════════════════════════════════════\n   Dark mode\n   ══════════════════════════════════════════════════════════ */\n.dark .acp-root { background: #121827; }\n.dark .acp-header { background: #1a2236; border-color: #2e3d52; }\n.dark .acp-header-text h1 { color: #e2e8f0; }\n.dark .acp-header-text p { color: #94a3b8; }\n.dark .acp-back-btn { background: #263348; color: #cbd5e1; }\n.dark .acp-back-btn:hover { background: #2e3d52; }\n.dark .acp-camera-card { background: #1a2236; box-shadow: 0 4px 24px rgba(0,0,0,0.3); }\n.dark .acp-result.success { background: #052e16; border-color: #166534; }\n.dark .acp-result-name { color: #e2e8f0; }\n.dark .acp-result.error { background: #1f0a10; border-color: #9f1239; color: #fb7185; }\n.dark .acp-status { color: #94a3b8; }\n.dark .acp-spinner { border-color: #2e3d52; border-top-color: #7eb3ff; }\n\n/* Dark: rich result popup */\n.dark .acp-result-popup { background: linear-gradient(135deg, #052e16, #064e3b); border-color: #065f46; }\n.dark .acp-action-badge.in  { background: #052e16; color: #4ade80; }\n.dark .acp-action-badge.out { background: #1e3a5f; color: #93c5fd; }\n.dark .acp-result-name { color: #e2e8f0; }\n.dark .acp-result-empid { color: #4b5e76; }\n.dark .acp-result-confidence { color: #94a3b8; }\n.dark .acp-result-confidence strong { color: #4ade80; }\n.dark .acp-time-pill.in  { background: #052e16; color: #4ade80; }\n.dark .acp-time-pill.out { background: #1e3a5f; color: #93c5fd; }\n.dark .acp-result-late { background: #3b1505; color: #fb923c; }\n.dark .acp-result-location { color: #64748b; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
